(function () {


    // CONFIGURATION
    const API_BASE_URL = "https://virtual-try-on-shopify.onrender.com";
    const PRIMARY_COLOR = "#769458"; // 

    const pathParts = window.location.pathname.split('/');
    let productHandle = pathParts[pathParts.length - 1];
    if (productHandle.includes('?')) productHandle = productHandle.split('?')[0];


    if (!window.location.pathname.includes('/products/')) return;

    // Detect if user is logged in (Shopify standard way)
    const customerId = window.ShopifyAnalytics?.meta?.page?.customerId || null;

    // Per-browser id so the guest limit is counted per device rather than per IP.
    // Mobile carriers here sit behind CGNAT, so many customers share one public
    // address and a per-IP cap locks all of them out at once.
    const deviceId = (function () {
        const KEY = '_lhp_vto_device';
        try {
            let id = localStorage.getItem(KEY);
            if (!id) {
                id = (crypto.randomUUID && crypto.randomUUID()) ||
                     (Date.now().toString(36) + Math.random().toString(36).slice(2, 12));
                localStorage.setItem(KEY, id);
            }
            return id;
        } catch (err) {
            return null;  // private mode / storage blocked — server falls back to IP
        }
    })();

    // 2. Robust Product Form Detection
    function findAddToCartContainer() {
        // List of common Shopify selectors for Add to Cart forms
        const selectors = [
            'form[action*="/cart/add"]',
            '.shopify-product-form',
            '.product-form',
            'form[id^="product_form_"]',
            '[data-type="add-to-cart-form"]',
            '.purchase-details',
            '.add-to-cart-container'
        ];

        for (let selector of selectors) {
            const el = document.querySelector(selector);
            if (el) {

                return el;
            }
        }

        // Fallback: Find the button that says "Add to cart" and get its parent form
        const buttons = Array.from(document.querySelectorAll('button, input[type="button"], input[type="submit"]'));
        const atcBtn = buttons.find(b => {
            const text = (b.innerText || b.value || "").toLowerCase();
            return text.includes('add to cart') || text.includes('add to bag') || text.includes('buy it now');
        });

        if (atcBtn) {

            return atcBtn.closest('form') || atcBtn.parentElement;
        }

        return null;
    }

    function injectButton() {
        if (document.getElementById('vton-trigger-btn')) return;

        const container = findAddToCartContainer();
        if (!container) {

            return;
        }

        const btn = document.createElement('button');
        btn.id = 'vton-trigger-btn';
        btn.type = 'button';
        btn.innerHTML = '✨ Virtual Try-On';
        btn.style = `
            width: 100%;
            margin-top: 10px;
            padding: 15px;
            background: linear-gradient(135deg, ${PRIMARY_COLOR}, #bde694);
            color: white;
            border: none; border-radius: 8px;
            font-weight: bold; cursor: pointer;
            font-size: 16px; transition: transform 0.2s, box-shadow 0.2s;
            box-shadow: 0 4px 15px rgba(0,0,0,0.1);
        `;

        btn.onmouseover = () => btn.style.transform = 'scale(1.02)';
        btn.onmouseout = () => btn.style.transform = 'scale(1)';
        btn.onclick = (e) => {
            e.preventDefault();
            openModal();
        };

        // Append to the container (if it's a form, it will show up near the other buttons)
        container.appendChild(btn);

    }

    // 3. Create the Modal UI
    let modal = null;
    let isLimitReached = false;

    function createModal() {
        const modalHtml = `
            <div id="vton-modal" style="display:none; position:fixed; z-index:9999; left:0; top:0; width:100%; height:100%; background:rgba(0,0,0,0.8); backdrop-filter:blur(5px); align-items:center; justify-content:center;">
                <div style="background:white; padding:30px; border-radius:20px; max-width:500px; width:90%; position:relative; text-align:center; box-shadow: 0 20px 40px rgba(0,0,0,0.3);">
                    <span id="vton-close" style="position:absolute; right:20px; top:15px; font-size:28px; cursor:pointer; color:#888;">&times;</span>
                    <h2 style="margin-top:0; font-size:24px;">AI Virtual Try-On</h2>
                    <p id="vton-status-text" style="color:#666;">Upload a photo of yourself to see the magic!</p>
                    
                    <div id="vton-upload-area" style="border:2px dashed #ccc; padding:40px; border-radius:15px; margin:20px 0; cursor:pointer;">
                        <span style="font-size:40px;">📸</span>
                        <p>Click to upload your photo</p>
                        <input type="file" id="vton-file-input" accept="image/*" style="display:none;">
                    </div>

                    <div id="vton-processing" style="display:none;">
                        <div class="vton-loader"></div>
                        <p>AI is generating your look...</p>
                    </div>

                    <div id="vton-result" style="display:none;">
                        <img id="vton-result-img" style="width:100%; border-radius:10px; margin-bottom:15px;">
                        <div style="display:flex; gap:8px; justify-content:center; flex-wrap:wrap;">
                            <button id="vton-share" style="background:${PRIMARY_COLOR}; color:#fff; border:none; padding:10px 20px; border-radius:5px; cursor:pointer; font-weight:bold;">Share this look</button>
                            <button id="vton-download" style="background:#fff; color:#444; border:1px solid #ccc; padding:10px 20px; border-radius:5px; cursor:pointer;">Save image</button>
                        </div>

                        <!-- Shown only when the browser has no native share sheet (mostly desktop) -->
                        <div id="vton-share-fallback" style="display:none; margin-top:15px;">
                            <div style="display:flex; gap:8px; justify-content:center; flex-wrap:wrap;">
                                <a id="vton-share-wa" href="#" target="_blank" rel="noopener" style="background:#25D366; color:#fff; padding:9px 16px; border-radius:5px; text-decoration:none; font-size:14px;">WhatsApp</a>
                                <a id="vton-share-fb" href="#" target="_blank" rel="noopener" style="background:#1877F2; color:#fff; padding:9px 16px; border-radius:5px; text-decoration:none; font-size:14px;">Facebook</a>
                                <button id="vton-share-copy" style="background:#eee; color:#444; border:none; padding:9px 16px; border-radius:5px; cursor:pointer; font-size:14px;">Copy link</button>
                            </div>
                            <p style="font-size:11px; color:#999; margin:10px 0 0;">For Instagram, save the image and upload it from the app.</p>
                        </div>
                    </div>

                    <div id="vton-limit-reached" style="display:none;">
                        <p style="color:red; font-weight:bold;">Tries limit reached!</p>
                        <p id="vton-limit-msg">Log in to get 2 more tries every day.</p>
                        <a id="vton-limit-login" href="/account/login" style="display:inline-block; background:${PRIMARY_COLOR}; color:white; padding:10px 20px; border-radius:5px; text-decoration:none; margin-top:10px;">Login / Sign Up</a>
                    </div>

                    <p id="vton-tries-left" style="font-size:12px; color:#999; margin-top:15px;"></p>
                </div>
            </div>
            <style>
                .vton-loader { border: 4px solid #f3f3f3; border-top: 4px solid ${PRIMARY_COLOR}; border-radius: 50%; width: 40px; height: 40px; animation: vton-spin 1s linear infinite; margin: 0 auto 15px; }
                @keyframes vton-spin { 0% { transform: rotate(0deg); } 100% { transform: rotate(360deg); } }
            </style>
        `;
        document.body.insertAdjacentHTML('beforeend', modalHtml);
        modal = document.getElementById('vton-modal');
        document.getElementById('vton-close').onclick = () => modal.style.display = 'none';
        document.getElementById('vton-upload-area').onclick = () => document.getElementById('vton-file-input').click();
        document.getElementById('vton-file-input').onchange = handleUpload;
        document.getElementById('vton-share').onclick = shareResult;
        document.getElementById('vton-download').onclick = downloadResult;
        document.getElementById('vton-share-copy').onclick = copyResultLink;
    }

    function openModal() {
        if (!modal) createModal();
        modal.style.display = 'flex';

        if (isLimitReached) {
            showLimitReached();
            return;
        }

        // Reset view
        document.getElementById('vton-upload-area').style.display = 'block';
        document.getElementById('vton-processing').style.display = 'none';
        document.getElementById('vton-result').style.display = 'none';
        document.getElementById('vton-limit-reached').style.display = 'none';
    }

    async function handleUpload(e) {
        const file = e.target.files[0];
        if (!file) return;

        document.getElementById('vton-upload-area').style.display = 'none';
        document.getElementById('vton-processing').style.display = 'block';

        const reader = new FileReader();
        reader.onloadend = async () => {
            const base64Image = reader.result;

            try {
                const resp = await fetch(`${API_BASE_URL}/api/v1/try-on`, {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({
                        handle: productHandle,
                        model_image: base64Image,
                        customer_id: customerId,
                        device_id: deviceId
                    })
                });

                const data = await resp.json();

                if (resp.status === 403) {
                    isLimitReached = true;
                    updateTries(0);
                    showLimitReached();
                } else if (data.task_id) {
                    isLimitReached = false;
                    updateTries(data.remaining);
                    pollStatus(data.task_id);
                } else {
                    alert("Error: " + data.detail);
                    openModal();
                }
            } catch (err) {
                alert("API Connection failed.");
                openModal();
            }
        };
        reader.readAsDataURL(file);
    }

    // Polling is not just how the customer sees their look — the server only copies
    // the finished image into Storage when this endpoint is called. An unhandled
    // rejection here used to kill the loop silently and lose a generated, paid-for
    // image, so every failure mode is now caught and retried.
    const POLL_INTERVAL_MS = 3000;
    const POLL_MAX_MS = 5 * 60 * 1000;   // tryon-max finishes in well under a minute
    const POLL_MAX_ERRORS = 8;           // consecutive network/5xx failures tolerated

    async function pollStatus(taskId) {
        const startedAt = Date.now();
        let errors = 0;

        const check = async () => {
            if (Date.now() - startedAt > POLL_MAX_MS) {
                showTakingLong();
                return;
            }
            try {
                const resp = await fetch(`${API_BASE_URL}/api/v1/status/${taskId}`);
                if (!resp.ok) throw new Error(`HTTP ${resp.status}`);
                const data = await resp.json();   // throws on a 502 HTML body
                errors = 0;

                if (data.status === 'completed') {
                    showResult(data.result);
                } else if (data.status === 'error' || data.status === 'failed') {
                    alert("AI Generation failed.");
                    openModal();
                } else {
                    setTimeout(check, POLL_INTERVAL_MS);
                }
            } catch (err) {
                // A sleeping phone, a dropped connection, or Render waking from
                // idle. Back off and keep asking rather than abandoning the task.
                errors += 1;
                if (errors >= POLL_MAX_ERRORS) {
                    showTakingLong();
                    return;
                }
                setTimeout(check, POLL_INTERVAL_MS * Math.min(errors, 4));
            }
        };
        check();
    }

    // Giving up on watching is not giving up on the image: the server reconciles
    // abandoned sessions against the AI on its own, so the look is still saved for
    // the shop even when this browser stops looking.
    function showTakingLong() {
        document.getElementById('vton-processing').style.display = 'none';
        alert("This is taking longer than usual. Your look is still being made and "
            + "will be saved \u2014 please try again in a moment.");
        openModal();
    }

    // Cached up front so shareResult() can call navigator.share() synchronously
    // inside the click — Safari drops the user activation if share() is awaited
    // behind a fetch, and silently refuses.
    let lastResultUrl = null;
    let lastResultFile = null;

    function showResult(imgUrl) {
        document.getElementById('vton-processing').style.display = 'none';
        document.getElementById('vton-result').style.display = 'block';
        document.getElementById('vton-result-img').src = imgUrl;

        lastResultUrl = imgUrl;
        lastResultFile = null;
        document.getElementById('vton-share-fallback').style.display = 'none';

        fetch(imgUrl)
            .then(r => r.ok ? r.blob() : Promise.reject(r.status))
            .then(blob => {
                lastResultFile = new File([blob], 'langerhans-try-on.png', { type: blob.type || 'image/png' });
            })
            .catch(() => { /* no file — sharing degrades to a plain link */ });
    }

    const SHARE_TEXT = 'Check out my virtual try-on from Langerhans Pharmacy!';

    async function shareResult() {
        const pageUrl = window.location.href;

        // Native sheet with the image attached. This is the only route that reaches
        // Instagram — Instagram has no web share URL to link to.
        if (lastResultFile && navigator.canShare && navigator.canShare({ files: [lastResultFile] })) {
            try {
                await navigator.share({ files: [lastResultFile], text: `${SHARE_TEXT} ${pageUrl}` });
                return;
            } catch (err) {
                if (err && err.name === 'AbortError') return;  // dismissed, not failed
            }
        }

        // Native sheet with just a link.
        if (navigator.share) {
            try {
                await navigator.share({ title: 'My Virtual Try-On', text: SHARE_TEXT, url: pageUrl });
                return;
            } catch (err) {
                if (err && err.name === 'AbortError') return;
            }
        }

        showShareFallback();
    }

    function showShareFallback() {
        const pageUrl = window.location.href;
        // Facebook's sharer takes a single URL, so we point it at the try-on image —
        // the look is the thing worth sharing. Falls back to the product page if the
        // result URL is somehow missing.
        document.getElementById('vton-share-fb').href =
            'https://www.facebook.com/sharer/sharer.php?u=' + encodeURIComponent(lastResultUrl || pageUrl);
        // WhatsApp takes free text, so it can carry both the look and where to buy it.
        document.getElementById('vton-share-wa').href =
            'https://wa.me/?text=' + encodeURIComponent(
                SHARE_TEXT + (lastResultUrl ? ' ' + lastResultUrl : '') + ' ' + pageUrl);
        document.getElementById('vton-share-fallback').style.display = 'block';
    }

    async function copyResultLink() {
        try {
            await navigator.clipboard.writeText(lastResultUrl || window.location.href);
            const btn = document.getElementById('vton-share-copy');
            const label = btn.innerText;
            btn.innerText = 'Copied!';
            setTimeout(() => { btn.innerText = label; }, 1500);
        } catch (err) {
            alert('Could not copy the link.');
        }
    }

    async function downloadResult() {
        if (!lastResultUrl) return;
        try {
            const blob = lastResultFile || await (await fetch(lastResultUrl)).blob();
            const objectUrl = URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = objectUrl;
            a.download = 'langerhans-try-on.png';
            document.body.appendChild(a);
            a.click();
            a.remove();
            URL.revokeObjectURL(objectUrl);
        } catch (err) {
            window.open(lastResultUrl, '_blank');  // last resort — let them save it manually
        }
    }

    function showLimitReached() {
        document.getElementById('vton-processing').style.display = 'none';
        document.getElementById('vton-limit-reached').style.display = 'block';

        // Already logged in? Then "log in for more" is useless advice — their
        // daily allowance simply resets tomorrow.
        if (customerId) {
            document.getElementById('vton-limit-msg').innerText =
                "You've used today's tries. Come back tomorrow for 2 more.";
            document.getElementById('vton-limit-login').style.display = 'none';
        }
    }

    function updateTries(remaining) {
        const text = remaining !== undefined ? `Tries remaining: ${remaining}` : "";
        document.getElementById('vton-tries-left').innerText = text;
    }

    injectButton();
    setInterval(injectButton, 2000);
})();
